import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

const applyDocumentLang = () => {
  document.documentElement.lang = i18n.language;
};

i18n
  .use(Backend)
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },
    ns: ['translation', 'countries'],
    backend: {
      loadPath: `/locales/{{lng}}/{{ns}}.json?v=${import.meta.env.APP_VERSION}`,
    },
  })
  .then(applyDocumentLang);

i18n.on('languageChanged', applyDocumentLang);
